import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"



  interface Emits {
    (e: 'close'): void
  }

  // emit
  
export default /*@__PURE__*/_defineComponent({
  __name: 'CloseButton',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

  const emit = __emit

  // handlers
  const handleClick = () => {
    emit('close')
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _withModifiers(handleClick, ["stop"]),
    class: "ts-x-black bg-grey-200"
  }))
}
}

})